// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__-yoRx","inputWrap":"CustomTip_inputWrap__7KkZk"};